import { StateCreator } from 'zustand';
import { IDocumentManagementPacketsSlice } from './types';

const initState = {
  loadingDocumentManagementPackets: false,
  packets: [],
};

export const documentManagementPacketsSlice: StateCreator<
  IDocumentManagementPacketsSlice
> = (set) => ({
  ...initState,

  setPackets: (packets) => {
    set({ packets });
  },
});
